/* @flow */

import { patchMembership } from 'src/shared/domain/membership/action/membershipActions';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import {
  convertModerationPostToNotification,
  convertModerationAcceptedToNotification,
  convertModerationAcceptedAndSlackToNotification,
  convertModerationRejectedToNotification,
} from 'src/shared/app/moderation/util/moderationUtils';

export function registerModerationOptin(eventId: number) {
  return patchMembership(eventId, {
    flags: {
      moderation_optin_completed: true,
    },
  });
}

export function showModerationPostBanner() {
  return queueNotification(convertModerationPostToNotification());
}

export function showModerationAcceptedBanner() {
  return queueNotification(convertModerationAcceptedToNotification());
}

export function showModerationRejectedBanner() {
  return queueNotification(convertModerationRejectedToNotification());
}

export function showModerationAcceptedAndSlackBanner() {
  return queueNotification(convertModerationAcceptedAndSlackToNotification());
}
